export interface WorkRow { id: number; label: string; status: string; warehouseName: string | null }
export interface WorkPage { canOpen: boolean; rows: WorkRow[]; total: number; nextCursor: number | null }
export interface WorkOverview {
  access: { picks: boolean; stockTakes: boolean; dispatch: boolean; scan: boolean };
  stats: { pendingPickLists: number | null; inProgressPickLists: number | null; activeStockTakes: number | null; pendingDispatches: number | null };
  assigned: WorkPage | null;
}
export function workTarget(kind: string, id: number) { return `/${kind === 'picks' ? 'pick' : kind === 'stock-takes' ? 'stock-take' : 'dispatch'}/${id}`; }
